export default ({ app }) => {
  app.router.beforeEach((to, from, next) => {
    // console.log('beforeEach', to.path);
    // window.scrollTo({top: 0})
    next();
  });
  app.router.afterEach(() => {
    // window.scrollTo({ top: 0 });
    // console.log('afterEach', to.path);
  });
};
